import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { DetailsActionContext } from "./DetailsActionContext";

function useGet() {
  const { setElement } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get("headers", id)
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
